// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "./polyfills";

import Vue from "vue";
import VueRouter from "vue-router";
import VueSanitize from "vue-sanitize";
import VModal from "vue-js-modal";
import App from "./App";

process.env.NODE_CONFIG_DIR = "./config.js";

// Plugins
import GlobalComponents from "./globalComponents";
import GlobalDirectives from "./globalDirectives";
import { NotificationPlugin } from "./components/NotificationPlugin";
import { ProgressPlugin } from "./plugins/progress.plugin";

// MaterialDashboard plugin
import MaterialDashboard from "./material-dashboard";
import "vue-select/dist/vue-select.css";

import { router } from "./_services/router";

Vue.use(VueRouter)
  .use(VueSanitize)
  .use(MaterialDashboard)
  .use(GlobalComponents)
  .use(GlobalDirectives)
  .use(NotificationPlugin)
  .use(VModal)
  .use(ProgressPlugin);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: h => h(App),
  router,
});
